import { render, staticRenderFns } from "./SettingsTabOptions.vue?vue&type=template&id=01938490&"
import script from "./SettingsTabOptions.vue?vue&type=script&lang=js&"
export * from "./SettingsTabOptions.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTabOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports